<div class="container p-4" style="    max-width: 1320px;">
    <div class="card">
        <h3>KNET Payment</h3>
        <br>
        <div>
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">
                <img src="assets/loader.gif" style="width: 80px !important;"/>
                <p i18n="knet_thank_you">Thank you for placing your order.
                    You will be now redirected to KNET payment gateway to complete your order
                    payment.</p>
            </div>

            <div class="text-center p-t-10" *ngIf="payment_button_visibility"> <a href="{{gateway_link}}" class="btn btn-primary" target="_blank">Continue to payment gateway</a></div>


        </div>


    </div>


</div>

